import { SVGProps } from 'react'

const CloseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1015 1.32135C11.3944 1.02845 11.3944 0.553579 11.1015 0.260686C10.8086 -0.0322077 10.3337 -0.0322077 10.0408 0.260686L5.68109 4.62043L1.32135 0.260686C1.02845 -0.0322077 0.553579 -0.0322077 0.260686 0.260686C-0.0322077 0.553579 -0.0322077 1.02845 0.260686 1.32135L4.62043 5.68109L0.260686 10.0408C-0.0322077 10.3337 -0.0322077 10.8086 0.260686 11.1015C0.553579 11.3944 1.02845 11.3944 1.32135 11.1015L5.68109 6.74175L10.0408 11.1015C10.3337 11.3944 10.8086 11.3944 11.1015 11.1015C11.3944 10.8086 11.3944 10.3337 11.1015 10.0408L6.74175 5.68109L11.1015 1.32135Z"
        fill="#1A1A25"
      />
    </svg>
  )
}

export default CloseIcon
